import { defineMessages } from "react-intl-next";

export const messages = defineMessages({
    migrationResourcesCardTitle: {
        id: "fastshift.relationships-card.title.migration-resources",
        defaultMessage: "Migration resources",
        description: "Title for the Migration Resources card"
    },
    migrationResourcesCardDescription: {
        id: "fastshift.relationships-card.description.migration-resources",
        defaultMessage:
            "Effortlessly find answers through our curated collection of help articles, providing practical tips and solutions for every phase of your cloud journey.",
        description: "Description for the Migration Resources card"
    },
    migrationResourcesCardButton: {
        id: "fastshift.relationships-card.button.migration-resources",
        defaultMessage: "View Articles",
        description: "Button text for the Migration Resources card"
    }
});
